import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 10l-2 1l8 4l8 -4l-2 -1","key":"svg-0"}],["path",{"d":"M4 15l8 4l8 -4","key":"svg-1"}],["path",{"d":"M12 4v7","key":"svg-2"}],["path",{"d":"M15 8l-3 3l-3 -3","key":"svg-3"}]]

const IconStackPush = createReactComponent('outline', 'stack-push', 'StackPush', __iconNode);

export default IconStackPush;